import { db, elasticQuery, ELASTIC_SEARCH_CAMPAIGNS_INDEX } from '../../firebase'
import {message} from 'ant-design-vue'
import { deleteData, addData} from '../../firebaseCRUD'

export const Campaigns = db.collection('campaigns')
export const Drafts = db.collection('drafts')
export const Archives = db.collection('archive')

export const getCampaignById = id => Campaigns.doc(id)

export const getCampaignsByAuthorId = authorID => Campaigns.where('author_id', '==', authorID)

export const getCampaignsByIds = async (ids) => {
    return elasticQuery({
        model: ELASTIC_SEARCH_CAMPAIGNS_INDEX,
        body: {
            query: {
               ids: {
                   values: ids
               }
            }
        }
    });
}
export const getFavorites = (uid) => Campaigns.where(`favorites.${uid}`, '==', true) 
export const getDrafts = (uid) => Drafts.where('author_id', '==', uid)
export const getArchives = (uid) => Archives.where('author_id', '==', uid) 
export const archiveCampaign = async (response, campData) => {
    if (response.data.total.value > 0) {
        message.error('Campaign has crossprom requests. Cannot be archived!')
    } else {
        message.info('The campaign is sent to archive')
        
      
        const removeCamp = await deleteData({
            collection: 'campaigns',
            id: campData.id
        })

        const addCamp = await addData({
            collection: 'archive',
            data: campData
        }) 
        return Promise.all([removeCamp, addCamp])
    }
}
export const restoreCampaign = async (campData) => {

    const existingCampaign = await Campaigns.where('title', '==', campData.title).get()
    if(!existingCampaign.empty) {
        message.error('This campaign is already published on the platform.')
        return false
    }
    message.success('The campaign is restored from archive')

    await deleteData({
        collection: 'archive',
        id: campData.id
    })

    await addData({
        collection: 'campaigns',
        data: campData
    })
    
    return true
}
export const removeFromFavorites = async (campData, uid) => {
    message.info('The campaign is removed from favorites')
    const campaignRef = Campaigns.doc(campData.id)
    db.runTransaction(transaction => {
        return transaction.get(campaignRef) 
            .then(
                (campaign) => {
                    const data = campaign.data()
                    data.favorites[uid] = false
                    transaction.update(campaignRef, {favorites: data.favorites})
            })
    })
    .catch(console.error)
}